'use client';
import Image from 'next/image';
import { useState } from 'react';

import { UiKitLightboxBase } from '@/fo/ui/kit/lightbox/base';

import { styles } from './UiKitImagePreview.styles';

export interface Image {
  id: string;
  type: 'image' | 'video';
  src: string;
  alt: string;
}

export interface UiKitImagePreviewProps {
  images: Image[];
  className?: string;
}

export function UiKitImagePreview({
  images,
  className
}: UiKitImagePreviewProps) {
  const slots = styles();
  const [open, setOpen] = useState(false);
  const [initialIndex, setInitialIndex] = useState(0);

  const onButtonCLick = (index: number) => {
    setInitialIndex(index);
    setOpen(true);
  };

  return (
    <div className={slots.base({ className })}>
      {images.map((image: Image) => (
        <button
          onClick={() => onButtonCLick(Number(image.id))}
          key={image.id}
        >
          <Image
            className="bg-blue-light cursor-pointer"
            src={image.src}
            width={100}
            height={100}
            alt=""
          />
        </button>
      ))}

      <UiKitLightboxBase
        open={open}
        onOpenChange={() => setOpen(!open)}
        initialIndexSlide={initialIndex}
        images={images}
      />
    </div>
  );
}
